import { render, staticRenderFns } from "./EventoImagen.vue?vue&type=template&id=55af58bc&scoped=true"
import script from "./EventoImagen.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoImagen.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EventoImagen.vue?vue&type=style&index=0&id=55af58bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55af58bc",
  null
  
)

export default component.exports